import { render } from "./GroupItem.vue?vue&type=template&id=7e24f7d0&scoped=true&bindings={\"id\":\"props\",\"groupLeader\":\"props\",\"groupName\":\"props\",\"members\":\"props\",\"notes\":\"props\",\"note\":\"data\",\"group\":\"options\",\"getGroups\":\"options\",\"addNote\":\"options\",\"removeGroup\":\"options\",\"removemember\":\"options\"}"
import script from "./GroupItem.vue?vue&type=script&lang=js"
export * from "./GroupItem.vue?vue&type=script&lang=js"

import "./GroupItem.vue?vue&type=style&index=0&id=7e24f7d0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7e24f7d0"

export default script